<template>
  <!-- Displays the logged in user. -->
  <Account></Account>

  <!-- Header -->
   <!-- <div v-if="brandService.getName() === Brand.HIS" class="bg-white">
    <header>
      <Navbar @cta-clicked="ctaClicked" :links="headerLinks" :portal="brandService.getPortalUrl()"/>
    </header>
  </div> -->
  <div v-if="brandService.getName() === Brand.NEX"  class="bg-transparent">
    <!--
      The ticker and the nav share one fixed container so the ticker always sits
      above the menu instead of being overlapped by it.
    -->
    <div class="fixed top-0 left-0 w-full z-50">
      <div ref="tickerEl">
        <HeroBanner :announcement="route.path === '/' ? brandService.getHomeAnnouncement() : ''"/>
      </div>
     <header class="z-50 header-nav" :class="[
      'w-full transition-colors duration-300 z-50',
      isScrolled ? 'bg-white text-black' : 'bg-transparent text-white'
    ]">
      <nav class="flex items-center justify-between p-6 lg:px-8 max-w-full" aria-label="Global">
        <div class="flex lg:flex-1">
          <a href="/" class="-m-1.5 p-1.5">
            <span class="sr-only">Your Company</span>
            <Logo />
          </a>
        </div>
        <div class="flex lg:hidden">
          <button type="button" class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-black" @click="mobileMenuOpen = true">
            <span class="sr-only">Open main menu</span>
            <MenuIcon class="size-6" aria-hidden="true" />
          </button>
        </div>
        <div class="hidden lg:flex lg:gap-x-12">
          <a v-for="item in headerLinks" :key="item.name" :href="item.href" class="text-sm/6 font-poppins text-black no-underline hover:border hover:border-solid hover:border-brand-primary px-6 py-1 rounded-full">{{ item.name }}</a>
        </div>
        <div class="hidden lg:flex lg:flex-1 lg:justify-end lg:gap-x-6">
          <a href="/about-us" class="text-sm/6 font-poppins text-black no-underline border border-solid border-brand-primary px-6 py-1 rounded-full hover:bg-black hover:text-white bg-transparent">About Us</a>
          <a href="https://my.nexee.au" class="text-sm/6 font-poppins text-black no-underline border border-solid border-brand-primary px-6 py-1 rounded-full hover:bg-black hover:text-white bg-transparent">Log in</a>
        </div>
      </nav>
      <Dialog class="lg:hidden" @close="mobileMenuOpen = false" :open="mobileMenuOpen">
        <div class="fixed inset-0 z-100" />
        <DialogPanel class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 max-w-sm sm:ring-1 sm:ring-white/10">
          <div class="flex items-center justify-between">
            <a href="#" class="-m-1.5 p-1.5">
              <span class="sr-only">Your Company</span>
              <Logo />
            </a>
            <button type="button" class="-m-2.5 rounded-md p-2.5 text-black" @click="mobileMenuOpen = false">
              <span class="sr-only">Close menu</span>
              <XIcon class="size-6" aria-hidden="true" />
            </button>
          </div>
          <div class="mt-6 flow-root">
            <div class="-my-6 divide-y divide-gray-500/25">
              <div class="space-y-2 py-6 font-poppins text-center">
                <a v-for="item in navigation" :key="item.name" :href="item.href" class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-bold text-black hover:text-gray-800" @click="mobileMenuOpen = false">{{ item.name }}</a>
              </div>
              <div class="py-6">
                <a href="https://my.nexee.au" class="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-white hover:bg-gray-800">Log in</a>
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
    </div>
    <!-- Holds open the space the fixed ticker occupies so it can't cover the page. -->
    <div :style="{ height: tickerHeight + 'px' }"></div>
    <!-- <header> -->
      <!-- <Navbar @cta-clicked="ctaClicked" :links="headerLinks" :portal="brandService.getPortalUrl()"/> -->
    <!-- </header> -->
  </div>

  <!-- Page -->
  <router-view />

  <!-- Footer -->
  <Footer v-show="brandService.getName() === Brand.NEX" class="" :main="footerLinks"></Footer>
  <!-- <div v-if="brandService.getName() === Brand.HIS" class="">
    <Footer class="" :main="footerLinks"></Footer>
  </div> -->
</template>

<script setup lang="ts">
import Footer from './components/structure/Footer.vue';
import Navbar from './components/structure/Navbar.vue';
import Container from './components/content/Container.vue';
import { injectStrict } from './plugins/vueServiceContainerPlugin';
import { CatalogAdapterInterface } from './adapters/catalogAdapterInterface';
import { OutageAdapterInterface } from './adapters/outageAdapterInterface';
import store from './store';
import { BrandServiceInterface } from './services/brand/brandServiceInterface';
import router from './router';
import Account from './components/Account.vue';
import { AuthenticationServiceInterface } from './services/authentication/authenticationServiceInterface';
import { Brand } from './services/integration/enums';
import Logo from './components/content/Logo.vue';
import HeroBanner from './components/content/HeroBanner.vue';
import { useRoute } from 'vue-router';
import { onMounted, ref, onBeforeUnmount } from 'vue';
import { MenuIcon, XIcon } from '@heroicons/vue/outline';

const route = useRoute();

const catalogAdapter = injectStrict<CatalogAdapterInterface>('CatalogAdapterInterface');
const outageAdapter = injectStrict<OutageAdapterInterface>('OutageAdapterInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
const authenticationService = injectStrict<AuthenticationServiceInterface>('AuthenticationServiceInterface');

// Data.
const footerLinks = [
  { name: 'Privacy', href: '/privacy-policy' },
  { name: 'Complaints', href: '/complaints' },
  { name: 'Legal', href: '/legal' },
  { name: 'Outages', href: '/outage' },
  { name: 'Family, Domestic & Sexual Violence Support', href: '/dfsv' }
];

let headerLinks = [
  { name: 'Features', href: '/#features' },
  { name: 'Plans', href: '/#plans' },
  { name: 'Contact', href: '/#contact' }
];

const navigation = [
  { name: 'Features', href: '/#features' },
  { name: 'Plans', href: '/#plans' },
  { name: 'Contact', href: '/#contact' }
];

const mobileMenuOpen = ref(false);
if (brandService.getName() === Brand.JAM) {
  headerLinks = [];
}

// Events
const unitiRedirect = async () => {
  router.push('/uniti');
};

// Events
const nexeeRedirect = async () => {
  router.push('/nexee');
};

if (brandService.getName() === Brand.JAM) {
  unitiRedirect();
}

if (brandService.getName() === Brand.HIS) {
  nexeeRedirect();
}
const getSalesPerson = async () => {
  const validSales = ['joshua.james@unitiinternet.com', 'jaben.heyworth@unitiinternet.com', 'abee.sharma@unitiinternet.com', 'kay.nguyen@unitiinternet.com', 'priya.ogirala@unitiinternet.com', 'aman.kaur@unitiinternet.com'];
  if (route.query.salesPerson && validSales.includes(route.query.salesPerson.toString().toLowerCase())) {
    store.commit('setSalesPerson', route.query.salesPerson.toString());
  }
};

// The ticker's height varies with the announcement text, so measure it rather
// than assuming a fixed line height.
const tickerEl = ref<HTMLElement | null>(null);
const tickerHeight = ref(0);
let tickerObserver: ResizeObserver | undefined;

onMounted(async () => {
  window.addEventListener('scroll', handleScroll);
  if (tickerEl.value) {
    tickerObserver = new ResizeObserver(() => {
      tickerHeight.value = tickerEl.value?.offsetHeight ?? 0;
    });
    tickerObserver.observe(tickerEl.value);
  }
  // get sales person
  await router.isReady();
  await getSalesPerson();
  store.commit('setPaymentAttempt', 0);
});

const isScrolled = ref(false);

function handleScroll () {
  isScrolled.value = window.scrollY > 50;
}

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
  tickerObserver?.disconnect();
});

const ctaClicked = () => {
  // When the CTA in the navbar is clicked, focus
  // the main address element if it exists.
  const el = document.getElementById('primary-address-search');
  if (el) {
    el.focus();
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
  } else {
    store.commit('setServiceQualification', null);
    router.push('/');
  }
};

// Get catalog for the rest of the site.
const getCatalog = async () => {
  const catalog = await catalogAdapter.getCatalog(brandService.getName());
  store.commit('setCatalog', catalog);
};
getCatalog();

// Initialise use account.
const getAccount = async () => {
  const account = await authenticationService.getAccount();
  store.commit('setAccount', account);
};
getAccount();

const getOutages = async () => {
  const outages = await outageAdapter.fetchOutages();
  store.commit('setOutages', outages);
};
getOutages();

const getAnnouncements = async () => {
  try {
    const announcements = await outageAdapter.fetchAnnouncements();
    store.commit('setAnnouncements', announcements);
  } catch (error) {
    // Announcements are non-critical, so a failure shouldn't break the page,
    // but swallowing it silently makes the banner impossible to debug.
    console.error('Failed to fetch announcements', error);
  }
};
getAnnouncements();

// Set the page title and favicon.
document.title = brandService.getTitle();
const link = document.createElement('link');
link.id = 'favicon';
link.rel = 'shortcut icon';
link.href = brandService.getFavicon();
document.head.appendChild(link);
</script>
